import { getImageBaseMask, getImageMattingResult, MattingType } from '@meitu/x-design-ai-api';
import { getLocaleStore } from '@/i18n';
import { base64Kit } from '@/utils/base64-kit';
import { getServerEnv } from '@/utils/common-kit';
import { imageToCanvas, loadImageAsync } from '@/utils/file-kit';
import { convertImageToOrigin } from '@/utils/image-resource-kit';

/**
 * 获取抠图结果
 *
 * @param uri - 链接地址 URI
 * @param upload - 可选；是否上传；默认值为 `false`
 * @param isIntl - 可选；是否是海外版
 * @param headers - 可选；HTTP 请求头
 * @param type - 可选；MAAT 上传类型
 */
export async function getCutoutResult(
    uri: string,
    upload = false,
    isIntl?: boolean,
    headers?: {
        'x-mtcc-client'?: string;
    },
    type?: MattingType,
) {
    const { $t } = getLocaleStore();
    const url = await base64Kit.getRemoteUrlAsync(uri);
    const maskResult = await getImageBaseMask({
        isUseNewAPI: true,
        params: {
            imageURL: convertImageToOrigin(url),
            mattingType: type,
            keepResolution: false,
        },
        ...(headers && { headers }),
    });

    const { mattingType, maskURL, useBlurFilterRun, foregroundEstimateImageURL, message, code } = maskResult;

    if (code === 0) {
        const img = await loadImageAsync(maskURL || '');
        const originCanvas = await loadImageAsync(url);
        const maskCanvas = await imageToCanvas(img);
        const mattingResult = await getImageMattingResult({
            width: maskCanvas.width,
            height: maskCanvas.height,
            image: originCanvas,
            maskImage: maskCanvas,
            useBlurFilterRun,
            foregroundEstimateImageURL,
        });
        const resultBase64 = mattingResult?.toDataURL();
        if (resultBase64) {
            let url = resultBase64;
            if (upload) {
                url = base64Kit.getCode(resultBase64);
            }
            return {
                url,
                msg_id: (maskResult as typeof maskResult & { msg_id?: string }).msg_id,
                mattingType,
                message,
                imageBaseMaskURL: maskURL,
                useBlurFilterRun,
                foregroundEstimateImageURL,
            };
        }
        return {
            error: $t((v) => v.utils.uploadNetworkErr),
        };
    }
    return {
        error: message,
    };
}
